// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#gallery[data-v-e67fe212]{background-color:#fafafa}.main-carousel-arrow[data-v-e67fe212]{position:absolute;top:50%;transform:translateY(-50%);z-index:1}.main-carousel-arrow--prev[data-v-e67fe212]{left:10px}.main-carousel-arrow--next[data-v-e67fe212]{right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
